import { bodyTextRadius } from './BodyTextStore';

import { bodyTextRadiusDefault } from './BodyTextStoreDefaults';

export const resetBodyTextRadius = () => bodyTextRadius.set(bodyTextRadiusDefault);
